import React from "react";

import Footer from "components/Footer";
import FullSizeLoading from "components/FullSizeLoading";

const LoadingWithFooter = () => {
  return (
    <div className="flex flex-1 flex-col">
      <FullSizeLoading />
      <Footer />
    </div>
  );
};

export default LoadingWithFooter;
